import { useEffect, useState } from 'react';
import { staffApi } from '@/lib/api';

export default function Reports() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    staffApi.get('/dashboard').then(({ data }) => setStats(data));
  }, []);

  if (!stats) return <p className="text-muted-ink text-sm">Loading reports…</p>;

  const rows = [
    ['Active Subscriptions', stats.activeSubscriptions],
    ['Pending Subscriptions', stats.pendingSubscriptions],
    ['Total Customers', stats.totalCustomers],
    ['New Customers (7 days)', stats.newCustomersThisWeek],
    ['Tiffins Redeemed Today', stats.tiffinsRedeemedToday],
    ['Low Balance Customers (≤3 remaining)', stats.lowBalanceCustomers],
    ['Subscriptions Expiring Soon (5 days)', stats.expiringSoon],
  ];

  return (
    <div className="space-y-4">
      <h1 className="font-heading text-2xl font-700 text-charcoal">Reports</h1>
      <p className="text-sm text-muted-ink">A quick operational snapshot. More detailed reports can be added as the business grows.</p>
      <div className="bg-white rounded-xl border border-border/40 divide-y divide-border/30 max-w-lg">
        {rows.map(([label, value]) => (
          <div key={label} className="flex justify-between px-4 py-3 text-sm" data-testid="report-row">
            <span className="text-muted-ink">{label}</span>
            <span className="font-semibold text-charcoal">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
